import React, { FC, useState } from 'react';
import { itemsApi } from '../../../api/services/items.service';

interface ContactManagerButtonProps {
  itemId: number;
  className?: string;
}


export const ContactManagerButton: FC<ContactManagerButtonProps> = ({ itemId, className }) => {
  const [state, setState] = useState<'idle' | 'loading' | 'sent' | 'error'>('idle');

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (state === 'loading' || state === 'sent') return;
    setState('loading');
    try {
      await itemsApi.requestStock(itemId);
      setState('sent');
    } catch (err: any) {
      // 429 (throttle) — фактически «слишком часто», для пользователя
      // это всё равно означает «обращение принято/повторите позже».
      if (err?.response?.status === 429) {
        setState('sent');
      } else {
        setState('error');
      }
    }
  };

  const label =
    state === 'sent'
      ? 'Запрос отправлен'
      : state === 'loading'
        ? 'Отправляем…'
        : state === 'error'
          ? 'Повторить'
          : 'Связаться с менеджером';

  return (
    <button
      onClick={handleClick}
      disabled={state === 'loading' || state === 'sent'}
      className={
        className ??
        `w-full py-3 rounded-full text-[12px] text-white font-medium border-0 cursor-pointer transition-colors ${
          state === 'sent' ? 'bg-red-600' : 'bg-[#e3282a] hover:bg-[#c81f21]'
        } disabled:cursor-default`
      }
    >
      {label}
    </button>
  );
};
